<template>
  <el-dialog
    :model-value="show"
    :show-close="false"
    width="500px"
    align-center
    style="padding: 20px 0"
    header-class="header-play"
    :before-close="handleClose"
    @open="dialogOpenFn"
  >
    <div class="login_dialog">
      <SvgIcon svg-id="#icon-yujingshezhi" class="svg-play" />
      <p style="font-weight: 500"> 您的诊所管家提醒您系统即将到期！ </p>
      <div class="light-text">
        合约到期后系统会自动停止服务，为确保您的业务正常持续开展，
      </div>
      <div class="light-text">请及时续费。或联系您的技术顾问协助。</div>
      <CustTable
        :dataList="data"
        :header-list="tableHeader"
        style="height: 200px; margin-top: 20px"
      >
        <template #title="scoped">
          <span class="title-play">
            {{ scoped.row.reason ?? '' }}
          </span>
        </template>
      </CustTable>
      <div class="dia-footer">
        <el-button @click="handleDayClose">3天内不再提醒</el-button>
        <el-button type="primary" @click="jumpFn">立即续费</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script lang="ts" setup>
import { useUserStore } from '@/store/modules/user'
import { ElMessage } from 'element-plus'
import { STORAGE_KEYS, useCache } from '@/libs/utils/constants'
import { isEmpty } from '@/libs/utils/data-checker'
import dayjs from 'dayjs'
const emit = defineEmits(['update:show'])
const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  data: {
    type: Object,
    default: {},
  },
})
const tableHeader = ref([
  {
    label: '功能名称',
    property: 'name',
  },
  {
    label: '到期时间',
    property: 'title',
    width: 200,
    useSlot: true,
  },
])
const loading = ref(false)
const router = useRouter()
const userStore = useUserStore()
const { wsCache } = useCache('localStorage')
const remainingDays = computed(() => {
  const expireTime = userStore.getUserInfo?.expireTime
  if (!expireTime) return null
  const expireDate = dayjs(expireTime)
  const today = dayjs().startOf('day')
  return expireDate.diff(today, 'day')
})
onBeforeMount(() => {})
// 弹窗关闭
const handleClose = () => {
  emit('update:show', false)
}
const handleDayClose = () => {
  const today = new Date().toDateString()
  wsCache.set('packageDialogClosedDate', today)
  emit('update:show', false)
}
// 弹窗开启
const dialogOpenFn = async () => {}
const jumpFn = () => {
  emit('update:show', false)
  router.push({
    name: '/manage',
    query: {
      tab: 'ProductCenter',
    },
  })
}
</script>

<style lang="scss" scoped>
.title-play {
  color: var(--dep-red);
}
:deep(.el-tabs__item:focus-visible) {
  box-shadow: none !important;
}
.login_dialog {
  font-family: 'PingFang SC', sans-serif;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 0 30px;

  .login-title {
    margin: 0 0 20px 0;
    font-size: 18px;
    font-weight: 600;
    color: #333;
    text-align: center;
  }
}

.dialog_body {
  padding: 20px;
  box-sizing: border-box;
}
.svg-play {
  font-size: 34px;
}
.light-text {
  color: var(--light-text);
}
.dia-footer {
  margin-top: 40px;
}
</style>
